import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'algolia': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAlgolia" */
        '@fortawesome/free-brands-svg-icons/faAlgolia'
    ),
    'apple': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faApple" */
        '@fortawesome/free-brands-svg-icons/faApple'
    ),
    'battle-net': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBattleNet" */
        '@fortawesome/free-brands-svg-icons/faBattleNet'
    ),
    'bilibili': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBilibili" */
        '@fortawesome/free-brands-svg-icons/faBilibili'
    ),
    'bitbucket': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBitbucket" */
        '@fortawesome/free-brands-svg-icons/faBitbucket'
    ),
    'black-tie': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBlackTie" */
        '@fortawesome/free-brands-svg-icons/faBlackTie'
    ),
    'btc': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBtc" */
        '@fortawesome/free-brands-svg-icons/faBtc'
    ),
    'codiepie': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCodiepie" */
        '@fortawesome/free-brands-svg-icons/faCodiepie'
    ),
    'ethereum': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faEthereum" */
        '@fortawesome/free-brands-svg-icons/faEthereum'
    ),
    'firefox-browser': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFirefoxBrowser" */
        '@fortawesome/free-brands-svg-icons/faFirefoxBrowser'
    ),
    'freebsd': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFreebsd" */
        '@fortawesome/free-brands-svg-icons/faFreebsd'
    ),
    'gitter': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGitter" */
        '@fortawesome/free-brands-svg-icons/faGitter'
    ),
    'keycdn': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faKeycdn" */
        '@fortawesome/free-brands-svg-icons/faKeycdn'
    ),
    'mendeley': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faMendeley" */
        '@fortawesome/free-brands-svg-icons/faMendeley'
    ),
    'mixer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faMixer" */
        '@fortawesome/free-brands-svg-icons/faMixer'
    ),
    'neos': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faNeos" */
        '@fortawesome/free-brands-svg-icons/faNeos'
    ),
    'playstation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPlaystation" */
        '@fortawesome/free-brands-svg-icons/faPlaystation'
    ),
    'rebel': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRebel" */
        '@fortawesome/free-brands-svg-icons/faRebel'
    ),
    'rendact': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWpressr" */
        '@fortawesome/free-brands-svg-icons/faWpressr'
    ),
    'sass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSass" */
        '@fortawesome/free-brands-svg-icons/faSass'
    ),
    'searchengin': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSearchengin" */
        '@fortawesome/free-brands-svg-icons/faSearchengin'
    ),
    'square-js': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareJs" */
        '@fortawesome/free-brands-svg-icons/faSquareJs'
    ),
    'square-odnoklassniki': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareOdnoklassniki" */
        '@fortawesome/free-brands-svg-icons/faSquareOdnoklassniki'
    ),
    'square-threads': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareThreads" */
        '@fortawesome/free-brands-svg-icons/faSquareThreads'
    ),
    'square-upwork': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareUpwork" */
        '@fortawesome/free-brands-svg-icons/faSquareUpwork'
    ),
    'ubuntu': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faUbuntu" */
        '@fortawesome/free-brands-svg-icons/faUbuntu'
    ),
    'waze': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWaze" */
        '@fortawesome/free-brands-svg-icons/faWaze'
    ),
    'wordpress': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWordpress" */
        '@fortawesome/free-brands-svg-icons/faWordpress'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>